import { render, staticRenderFns } from "./MailSegnalazioneEightD.vue?vue&type=template&id=7395ad34&scoped=true"
import script from "./MailSegnalazioneEightD.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneEightD.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneEightD.vue?vue&type=style&index=0&id=7395ad34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395ad34",
  null
  
)

export default component.exports